import { createSvgIcon } from "@mui/material";

export const ServiceFeeIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path d="M10 5V10H13.75M17.5 10C17.5 14.1394 14.1394 17.5 10 17.5C5.86064 17.5 2.5 14.1394 2.5 10C2.5 5.86064 5.86064 2.5 10 2.5C14.1394 2.5 17.5 5.86064 17.5 10Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'ServiceFeeIcon'
)
